import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import "./clues.css";
import { far } from "@fortawesome/free-regular-svg-icons";

library.add(fas)

const Clues = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container conoce-container">
      <div className="row">
        <div className="col-12">
            <div className="d-flex justify-content-center">
            <img src="../../images/asis_hola.gif" style={{height:"150px"}}></img>
            </div>
        </div>
        <div className="col-12">
          <div className="conoce_title">
            <h1><FontAwesomeIcon icon="fas fa-hospital" /> CLUES (Clave Única de Establecimiento de Salud)</h1>
          </div>
        </div>
      </div>
      <div className="row">
          <div className="col-12" >
<div class="accordion" id="accordionConoce">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        <FontAwesomeIcon icon="fas fa-book-medical" />&nbsp;¿Qué es una CLUES?
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
       "Es un identificador único, consecutivo e intransferible que asigna la Secretaría de Salud a través de la Dirección General de Información en Salud de manera obligatoria a cada establecimiento de salud, que exista en el territorio nacional, sea público, privado o social, y con la cual se identifica toda la información reportada por el mismo a cada uno de los componentes del Sistema Nacional de Información en Salud". (NOM-035-SSA3-2012)<br></br><br></br>
       "Todo establecimiento del SNS debe contar con CLUES” y 9.4.2 “Toda la información debe integrarse a través del Catálogo de Establecimientos en Salud, mismo que asigna una clave única de identificación a cada establecimiento (CLUES), por medio de la cual se organiza el inventario funcional de unidades del SNS, conforme a la institución y ubicación geográfica de pertenencia". (NOM-035-SSA3-2012)
       <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-book-medical" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
        {/* <span className="fa-stack fa-1x" style={{height: "25px"}}>
              <FontAwesomeIcon icon="fas fa-dollar-sign"  className="fa-stack-1x mt-0 mb-0" style={{color: "rgb(0,0,0)",}}  />
              <FontAwesomeIcon icon="fas fa-slash" className="fa-stack-1x mt-0 mb-0"  style={{color: "red",}}/>
          </span> */}
        <FontAwesomeIcon icon="fas fa-file-invoice-dollar" />&nbsp;¿Cuál es el costo del trámite? 
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        El trámite de CLUES es <b style={{paddingLeft: "0.5rem" }}>gratuito.</b>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-file-invoice-dollar" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
        {/* <div className="d-flex justify-content-between">
          <span className="d-flex align-items-center">El trámite de CLUES es <b style={{paddingLeft: "0.5rem" }}>gratuito.</b></span>
          <span className="fa-stack fa-3x" style={{height: "50px"}}>
              <FontAwesomeIcon icon="fas fa-dollar-sign"  className="fa-stack-1x mt-0 mb-0" style={{color: "rgb(105,28,49)",}}  />
              <FontAwesomeIcon icon="fas fa-slash" className="fa-stack-1x mt-0 mb-0"  style={{color: "red",}}/>
          </span>
          
        </div> */}
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapsetwo">
        <FontAwesomeIcon icon="fas fa-hospital-user" />&nbsp;¿Quién debe solicitar una CLUES?
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
          <ul>
             <li>Unidades Médicas: de Consulta Externa, Hospitalización y Observación de Medicina General o Especializada; Odontológica, Rehabilitación.</li>
             <li>Laboratorio: Clínico, Biológico, Farmacéutico.</li>
             <li>Centro de Diagnóstico: Detección Temprana, Radiología, Imagenología, Endoscopía, Audiometría, Espirometría, Optometría, Fundaciones de Salud.</li>
             <li>Centros de Tratamiento: Internamiento o Residenciales, Desintoxicación, Ambulatorios, Terapéuticos, de Seguimiento o Reinserción.</li>
             <li>Oficinas administrativas del Sector Salud.</li>
        </ul>
        Que sean fijos o móviles, que se encuentren en infraestructuras sin registro previo en CLUES y cuenten con accesos independientes.
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-hospital-user" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        <FontAwesomeIcon icon="fas fa-list-check" />&nbsp;Alta y Modificación de CLUES
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        <strong>Alta: </strong>“Se refiere al ingreso de datos de un establecimiento que no esá registrado, sea porque está en proceso de construcción, porque el establecimiento existe y no se había solicitado su ingreso, o bien porque se realiza una donación o transferencia de un establecimiento a una institución de salud. Lo anterior con el fin de obtener una CLUES.” <u>Se aplica en unidades nuevas y sustituciones.</u><br></br><br></br>
        <strong>Modificación: </strong>“Es la actualización de información asociada al establecimiento, excluyendo de ello el dato de la CLUES, Institución de pertenencia y el de entidad federativa.” <u>Aplicable en cambios que no afecten la infraestructura total de la unidad.</u><br></br><br></br> 
        <strong>Requisitos:</strong><br></br><br></br>
        <strong>Alta </strong>(asignación de clave) y <strong>Modificación </strong>(establecimientos que ya cuentan con CLUES) <u>En la fecha real en la que sucede o a más tardar 15 días después de la fecha de inicio de funcionamiento.</u><br></br><br></br>
        <ul>
             <li>Oficio de solicitud expedido por la unidad dirigido a:
                <ul>
                  <li>
                    En el caso de Oficinas Administrativas, Laboratorio y CETS de SSH; PGR, Fiscalía, Servicio Médico Estatal a la Dirección de Planeación, Presupuesto y Evaluación.  
                  </li>
                  <li>
                    En el caso de Oficinas Jurisdiccionales, UNEMES, Unidades Móviles y Clínica de Especialidades de SSH, a la Subdirección General de Prestación de Servicios.  
                  </li>
                  <li>
                    En el caso de Unidades Privadas, DIF, Cruz Roja Mexicana, Servicio Médico Municipal y Secretaría de Comunicaciones y Transporte, a la Jurisdicción correspondiente.  
                  </li>
                </ul>
             </li>
             <li>Formato Trámite de CLUES completamente requisitado y con datos cotejados con los Planos de construcción, Plantilla de Personal, Registro Sanitario, etc. y toda documentación oficial con la que cuente la unidad.</li>
             <li>3 fotografías del exterior de la unidad:
                <ul>
                  <li>
                    De frente donde se visualice claramente el nombre de la unidad.  
                  </li>
                  <li>
                    De costado derecho e izquierdo donde se visualice la ubicación de la unidad sobre la calle y los lugares aledaños.  
                  </li>
                </ul>
             </li>
             <li>Plano de construcción en el cual se visualice el total de las áreas, consultorios y camas de la unidad de manera completa y correcta.</li>
             <li>Registro sanitario, que contengan todos los datos cotejados con Planos de construcción, recibos de luz, agua o teléfono, y toda documentación oficial con la que cuente la unidad: 
                <ul>
                  <li>
                    Para unidades Hospitalarias: Licencia Sanitaria.
                  </li>
                  <li>
                    Para Unidades de Consulta Externa: Aviso de Funcionamiento.  
                  </li>
                </ul>
             </li>
             <li>RFC del establecimiento o del propietario del establecimiento.</li>
             <li>Máscara SINERHIAS.</li>
        </ul>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-list-check" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        <FontAwesomeIcon icon="fas fa-building-circle-xmark" />&nbsp;Baja de CLUES
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        “Es la modificación del estatus funcional del establecimiento (de operando a fuera de operación) que está registrado en el Catálogo y cuenta con una CLUES.”<br></br><br></br>
        <strong>Requisitos:</strong><br></br><br></br>
        <strong>Baja </strong>(unidades que han dejado de prestar servicios) <u>En la fecha real en la que sucede o a más tardar 15 días después de la fecha del cierre.</u><br></br><br></br>
        <ul>
             <li>Oficio de solicitud expedido por la unidad dirigido a:
                <ul>
                  <li>
                    En el caso de Oficinas Administrativas, Laboratorio y CETS de SSH; PGR, Fiscalía, Servicio Médico Estatal a la Dirección de Planeación, Presupuesto y Evaluación.  
                  </li>
                  <li>
                    En el caso de Oficinas Jurisdiccionales, UNEMES, Unidades Móviles y Clínica de Especialidades de SSH, a la Subdirección General de Prestación de servicios.  
                  </li>
                  <li>
                    En el caso de Unidades Privadas, DIF, Cruz Roja Mexicana, Servicio Médico Municipal y Secretaría de Comunicaciones y Transporte, a la Jurisdicción correspondiente.  
                  </li>
                </ul>
             </li>
        </ul>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-building-circle-xmark" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
        <FontAwesomeIcon icon="fas fa-address-book" />&nbsp;¿Cómo puedo tramitar la CLUES?
      </button>
    </h2>
    <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        <ol>
          <li>  
            <strong>Unidades Privadas, DIF, Cruz Roja Mexicana, Servicio Médico Municipal y Secretaría de Comunicaciones y Transporte</strong>
            <ul>
              <li>
                Acudir a la Jurisdicción Sanitaria que corresponda, para entregar requisitos completos y correctos en archivo electrónico o escaneados.<br></br><br></br>
                <a href="../Informacion/Jurisdicciones" target="_blank">Ver directorio de Jurisdicciones</a>
              </li>
            </ul>
          </li>
          <br></br>
          <li>    
            <strong>Oficinas Jurisdiccionales, UNEMES, Unidades Móviles y Clínica de Especialidades de SSH</strong>
            <ul>
              <li>
                Enviar los requisitos completos y correctos en archivo electrónico o escaneados a la Subdirección General de Prestación de Servicios.
              </li>
            </ul>
          </li>
          <br></br>
          <li>  
            <strong>Oficinas Administrativas, Laboratorio y CETS de SSH; PGR, FGR, Servicio Médico Estatal</strong>
            <ul>
              <li>
                Generar un Ticket con los requisitos completos y correctos en archivo electrónico o escaneados.
              </li>
            </ul>
          </li>
        </ol>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-address-book" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeven">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
        <FontAwesomeIcon icon="fas fa-circle-check" />&nbsp;¿Quiénes deberán de generar un Ticket? 
      </button>
    </h2>
    <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        <ol type="1">
          <li>  
            <strong>Las Jurisdicciones Sanitarias</strong> para realizar el trámite de:
            <ol type="a">
              <li>DIF,</li>
              <li>Cruz Roja Mexicana,</li>
              <li>Servicio Médico Municipal y</li>
              <li>Secretaría de Comunicaciones y Transporte.</li>
            </ol>
          </li>
          <br></br>
          <li>  
            <strong>La Subdirección General de Prestación de Servicios</strong> para realizar el trámite de:
            <ol type="a">
              <li>Unidades Privadas,</li>
              <li>Oficinas Jurisdiccionales de SSH,</li>
              <li>UNEMEs de SSH,</li>
              <li>Unidades Móviles de SSH y</li>
              <li>Clínica de Especialidades de SSH</li>
            </ol>
          </li>
          <br></br>
          <li>  
            <strong>Las Oficinas Administrativas, Laboratorio y CETS de SSH; PGR, Fiscalía, Servicio Médico Estatal</strong> deberán realizar un Ticket de forma directa.
          </li>
        </ol>
        <a href="../contenido/clues/Como generar un Ticket.pdf"  target="_blank">¿Cómo generar un ticket?</a>  
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-circle-check" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEight">
      <button class="accordion-button collapsed accordion-ejemplos" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
        <FontAwesomeIcon icon="fas fa-street-view" />&nbsp;Ejemplos de llenado y herramientas para validación de información  
      </button>
    </h2>
    <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
        <ul>
          <li>  
            Ejemplos de llenado e integración del expediente para el trámite de CLUES<br></br> 
            <a href="../contenido/clues/Ejemplos de llenado.pdf" target="_blank">Ver información</a>
          </li>
          <br></br>
          <li>  
            El código postal en SEPOMEX:<br></br> 
            <a href="https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/Descarga.aspx" target="_blank">https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/Descarga.aspx</a>
          </li>
          <br></br>
          <li>  
            La localidad debe estar registrada en el catálogo de localidades de INEGI (aplicar los filtros pertinentes para la entidad), en:<br></br> 
            <a href="https://www.inegi.org.mx/app/ageeml/" target="_blank">https://www.inegi.org.mx/app/ageeml/</a>
          </li>
          <br></br>
          <li>  
            Registro Nacional de Profesionistas y Cédula Profesional, para verificar que la Cédula reportada en los formatos sea la correcta:<br></br> 
            <a href="https://www.cedulaprofesional.sep.gob.mx/cedula/presidencia/indexAvanzada.action" target="_blank">https://www.cedulaprofesional.sep.gob.mx/cedula/presidencia/indexAvanzada.action</a>
          </li>
          <br></br>
          <li>  
            Georreferencia exacta del establecimiento utilizando Google Maps: <br></br> 
            <a href="https://www.google.com.mx/maps/" target="_blank">https://www.google.com.mx/maps/</a>
          </li>
        </ul>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon icon="fas fa-street-view" size="4x" style={{color: "rgb(105,28,49)",}} />
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
      </div>
    </div>
  );
};

export default Clues